import React from 'react'
import {Link} from 'react-router-dom'

const Support = (props) => {
    const ClickHandler = () =>{
        window.scrollTo(10, 0);
     }
    return(
        <section className="wpo-support-section mt-3 mb-3">
            <div className="container">
                <div className="wpo-support-wrapper">
                    <div className="wpo-support-text">
                        <h2>Tienes Alguna consulta adicional?</h2>
                        <p>Escribe a nuestro Whatsapp de soporte y con gusto te atenderemos!</p>
                    </div>
                    <div className="wpo-support-btn">
                        <Link onClick={ClickHandler} to="/contact">Escribir a Soporte</Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Support;